import { useEffect } from 'react';
import { useCalendarQuery } from '@gql/schema';
import { buildGroupsAndPeopleFromSelection } from '@secretescapes/cauldron';
import * as Sentry from '@sentry/react';
import { useAppState } from '@utils/useAppState';
import { useApplicationState } from '@utils/useApplicationState';
import { IFlightState } from '@features/Flights';
import { ALL_OFFERS } from './AvailabilityPresentation.utils';
import { useSelectionState } from './SelectionContext';

interface Props {
  flightsSelected: boolean;
  flightState: IFlightState;
}

export const useCalendar = ({ flightsSelected, flightState }: Props) => {
  const { saleId } = useAppState();
  const { affiliateCode, territoryCode } = useApplicationState();
  const { offerId, travellersSelection } = useSelectionState();

  const { people, groups } = buildGroupsAndPeopleFromSelection(travellersSelection);
  const { selectedAirport, selectedNights } = flightState;

  const { data, error, refetch, loading } = useCalendarQuery({
    variables: {
      saleId,
      affiliate: affiliateCode,
      territory: territoryCode,
      packageGroups: offerId !== ALL_OFFERS ? [offerId] : [],
      people,
      groups,
      nights: flightsSelected && selectedNights ? [selectedNights] : [],
      departureAirports: flightsSelected && selectedAirport.code ? [selectedAirport.code] : [],
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (error?.networkError) {
      Sentry.captureException(error.networkError);
    }
    error?.graphQLErrors.forEach(gqError => Sentry.captureException(gqError));
  }, [error]);

  return {
    calendar: data?.sale?.calendar,
    calendarError: !!error,
    calendarLoading: loading,
    calendarRefetch: refetch,
  };
};
